import { COLORS, FlexView } from '@cuemath/comps';
import React from 'react';
import styled from 'styled-components';
import { Text } from '@cuemath/web-comps';

import FloraImg from 'img/flora.png';
import PatternImg from 'img/percentage-pattern.png';

const Wrapper = styled(FlexView)`
  height: 200px;
  background: ${COLORS.BEIGE};
`;

const StyledFlexView = styled(FlexView)`
  height: 200px;
`;

const ImageWrapper = styled(FlexView)`
  background: ${COLORS.BLACK};
  height: 41px;
  width: 41px;
  border-radius: 50%;
`;

const ImageBackground = styled.div`
  height: 200px;
  background: url(${PatternImg});
  background-size: 300px;
`;

const GradeWrapper = styled(FlexView)`
  background: ${COLORS.YELLOW_3};
  border-radius: 16px;
`;

const GRADES = {
  '-1': 'LKG',
  0: 'KG',
  1: 'I',
  2: 'II',
  3: 'III',
  4: 'IV',
  5: 'V',
  6: 'VI',
  7: 'VII',
  8: 'VIII',
  9: 'IX',
  10: 'X',
  11: 'XI',
  12: 'XII',
};

function StudentInfo({ grade, name }) {
  return (
    <Wrapper>
      <ImageBackground>
        <StyledFlexView alignItems="center" justifyContent="center">
          <ImageWrapper alignItems="center" justifyContent="center">
            <img src={FloraImg} alt="" width="40px" height="40px" />
          </ImageWrapper>
          <GradeWrapper>
            <Text variant="body2">{`Grade ${GRADES[grade]}`}</Text>
          </GradeWrapper>
          <Text variant="h4">{name}</Text>
        </StyledFlexView>
      </ImageBackground>
    </Wrapper>
  );
}

export default StudentInfo;
